import { Button } from 'doraemon';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';

const ZlbConfirm = props => {
  const {
    width,
    title,
    onOk,
    onClose,
    content,
    footer,
    okText,
    cancelText,
    propsClass = '',
    propsModalClass,
    propsModalStyle,
    showLinkBtn,
    onLinkClick = () => {},
    linkBtnText,
    showCloselBtn,
    boldContent,
    iconfont = 'icon-zlb-a-weishezhi3x',
    showOkBtn = true,
    showCancelBtn = true,
    renderContent,
    closable,
  } = props;

  // 组件卸载
  const unmountComponent = () => {
    document.body.style.overflow = '';
    component && ReactDOM.render(React.cloneElement(component), div);
    ReactDOM.unmountComponentAtNode(div);
    div.remove();
  };
  // 点击取消
  const onCancel = clickFrom => {
    unmountComponent();
    onClose?.(clickFrom);
  };

  // 点击确认
  const onYes = () => {
    unmountComponent();
    onOk?.();
  };
  // 查看链接事件
  const onLink = () => {
    unmountComponent();
    onLinkClick?.();
  };

  const component = ReactDOM.createPortal(
    <div className={`${propsClass}`}>
      <div className="zlb-confirm-modal-mask" />
      <div className="zlb-confirm-modal">
        <div
          className={`confirm-modal-container ${propsModalClass}`}
          style={{ width, ...propsModalStyle }}
          onClick={() => !showOkBtn && onLink()}
        >
          {showCloselBtn && (
            <span
              onClick={e => {
                e.stopPropagation?.();
                showOkBtn ? onCancel() : onYes();
              }}
              className="zlb-confirm-close"
            />
          )}
          <div className={`confirm-modal-header ${content || renderContent ? '' : 'no-content'}`}>
            <div className="confirm-modal-title">
              {!content && <i className={`iconfont-zlb ${iconfont}`} />}
              {title}
            </div>
            {closable && (
              <i
                className="iconfont-zlb icon-zlb-close1 close-style"
                onClick={() => onCancel('icon')}
              />
            )}
          </div>
          <div className="confirm-modal-content">
            {renderContent?.()}
            {boldContent && <span className="bold-content">{boldContent}</span>}
            <span>{content}</span>
          </div>
          <div className="confirm-modal-footer">
            {footer || (
              <div className="default-btns">
                {showCancelBtn && (
                  <Button type="secondary" onClick={() => onCancel('btn')}>
                    {cancelText || '取消'}
                  </Button>
                )}
                {showLinkBtn && (
                  <Button type="secondary" onClick={onLink}>
                    {linkBtnText || '详情'}
                  </Button>
                )}
                {showOkBtn && (
                  <Button type="primary" onClick={onYes}>
                    {okText || '确定'}
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>,
    document.body,
  );

  const div = document.createElement('div');
  document.body.appendChild(div);
  ReactDOM.render(component, div);
  document.body.style.overflow = 'hidden';
};

export default ZlbConfirm;
